export const CUSTOMER_TERMS_VERSION_GQL_FIELD = 'acceptedCustomerTosV1Dot0'
export const CONTRACTOR_TERMS_VERSION_GQL_FIELD = 'acceptedContractorTosV1Dot0'
